import { ref, watch } from 'vue';
import { useNumericQueryParam, useQueryParam, useQueryString } from '../composables/useQueryString';
import { IScheduledCoachJob } from '../services/api/scheduleCoachingForm/types';
import { defineStore } from 'pinia';
import { debounce } from '../utils/debounce';

export const useScheduleCoachingFormTableStore = defineStore('scheduleCoachingFormTable', () => {
    // Local variables
    const scheduleCoachingForms = ref<IScheduledCoachJob[]>([]);

    const filteredScheduledForms = ref<IScheduledCoachJob[]>([]);

    const editForm = ref<IScheduledCoachJob | null>(null);

    const querystring = useQueryString();

    const { value: searchTerm } = useQueryParam('search', {
        defaultValue: '',
        updateMode: 'replace',
    });

    const page = useNumericQueryParam('page', {
        startIndex: 0,
        oneBased: true,
        updateMode: 'push',
    });

    const filterDebounced = debounce((newTerm: string) => {
        if (!newTerm) {
            filteredScheduledForms.value = [...scheduleCoachingForms.value];
        } else {
            const term = newTerm.toLowerCase();
            filteredScheduledForms.value = scheduleCoachingForms.value.filter((form) => {
                return form.title.toLowerCase().includes(term);
            });
        }
    }, 300);

    const setForms = (forms: IScheduledCoachJob[]) => {
        scheduleCoachingForms.value = [...forms];
        filterDebounced(searchTerm.value);
    };

    const changeSort = async (fieldId: string, order: 'asc' | 'desc') => {
        await querystring.setMany({ field: fieldId, order: order }, 'replace');
    };

    watch(searchTerm, (newTerm) => filterDebounced(newTerm), { immediate: true });

    return {
        scheduleCoachingForms,
        editForm,
        setForms,
        changeSort,
        page,
        searchTerm,
        filteredScheduledForms,
    };
});
